import { BodyLG, BodyMDB } from "../../typography";

import { DesktopNavItem } from "./components/DesktopNavItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MobileNavItem } from "./components/MobileNavItem";
import { NavLink } from "./components/NavLink";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { cn } from "@verse_core/shared_components/ClassName";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { navItems } from "./config/navConfig";
import { useLocation } from "react-router-dom";
import { useMobileMenu } from "./hooks/useMobileMenu";

export const NewNavBar = ({ isDark }: { isDark: boolean }) => {
  const { isMobileMenuOpen, toggleMobileMenu, closeMobileMenu } =
    useMobileMenu();
  const location = useLocation();
  const href = "/password-login?type=provider";
  const isActive =
    location.pathname !== "/" && href.includes(location.pathname);

  return (
    <div className="tw-flex tw-w-full tw-justify-end min1040:tw-justify-between">
      {/* Desktop Nav */}
      <div className={cn("tw-hidden tw-gap-x-[2em] min1040:tw-flex")}>
        {navItems.map((item) => (
          <DesktopNavItem key={item.title} {...item} isDark={isDark} />
        ))}
      </div>

      <div className="tw-flex tw-items-center tw-justify-end tw-gap-x-[2em] min1040:tw-flex-row">
        <NavLink
          href={href}
          className={cn(
            "tw-relative tw-hidden tw-h-[4.5em] tw-items-center tw-gap-[1em] tw-border-x-0 tw-border-b-[2px] tw-border-t-0 tw-border-solid tw-border-transparent min1040:tw-flex",
            isDark
              ? "tw-text-white hover:tw-border-white hover:tw-text-white"
              : "tw-text-gray-2 hover:tw-border-blue-1 hover:tw-text-gray-2",
            isActive ? (isDark ? "tw-border-white" : "tw-border-blue-1") : "",
          )}
        >
          <BodyLG
            className={cn(
              "tw-mb-0",
              isDark ? "tw-text-white" : "tw-text-gray-2",
            )}
          >
            Log In
          </BodyLG>
        </NavLink>
        <StandardButton
          className="tw-text-[16px]"
          style="primary-blue"
          onClick={() => {}}
        >
          <NavLink href="/contact">
            <BodyMDB className="tw-mb-0 tw-text-white">Get a demo</BodyMDB>
          </NavLink>
        </StandardButton>
        <FontAwesomeIcon
          icon={faBars}
          className={cn(
            "tw-text-[26px] min1040:tw-hidden",
            isDark ? "tw-text-white" : "tw-text-gray-4",
          )}
          onClick={toggleMobileMenu}
        />
      </div>

      {/* Mobile Nav */}
      <div
        className={cn(
          "tw-fixed tw-left-0 tw-top-[70px] tw-z-max tw-grid tw-h-screen tw-w-screen tw-overflow-hidden tw-bg-white tw-transition-all tw-duration-300",
          isMobileMenuOpen
            ? "tw-translate-y-0 tw-opacity-100"
            : "tw-pointer-events-none tw-translate-y-[-10px] tw-opacity-0",
        )}
      >
        <div className="tw-flex tw-flex-col tw-divide-y tw-divide-solid tw-divide-gray-light-1">
          {navItems.map((item) => (
            <MobileNavItem
              key={item.title}
              {...item}
              onCloseMobileMenu={closeMobileMenu}
            />
          ))}
          <div className="tw-px-[1em] tw-text-[16px]">
            <StandardButton
              style="primary-blue"
              className="tw-my-[1em] tw-w-full tw-rounded-[4px] tw-p-[10px]"
              onClick={() => {}}
            >
              <NavLink href={href}>
                <BodyMDB className="tw-mb-0 tw-text-white">Log In</BodyMDB>
              </NavLink>
            </StandardButton>
          </div>
        </div>
      </div>
    </div>
  );
};
